import { SplitClient as BitSplitClient } from "@moodys/mdc-frontend.services.split";

import { split } from "@moodys/federated";
import { Header } from "components/Header/index";
import { ANONYMOUS_DEFAULT, useUserInfo } from "hooks/useUserInfo/useUserInfo";

export const SplitClientHeader = () => {
  const { userEmail } = useUserInfo();
  const splitUserKey = userEmail || ANONYMOUS_DEFAULT;

  return (
    // Necessary for squads still using Split from Bit
    // BitSplitClient will be removed once all squads are migrated to NFE Split [MDCPT-52817]
    <BitSplitClient splitKey={splitUserKey}>
      <split.SplitClient splitKey={splitUserKey}>
        <Header />
      </split.SplitClient>
    </BitSplitClient>
  );
};
